import { Dayjs } from 'dayjs';

import { Config } from '@app/config/base';
import { SDate } from '@summit/core';

import { EboNameObject } from './ebo-name-object';

export abstract class EboObjectTimePeriod extends EboNameObject {
  startTime: Dayjs;
  endTime: Dayjs;

  constructor(jsonData?: Partial<EboObjectTimePeriod>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.startTime) {
        this.startTime = SDate.newUtc(jsonData.startTime);
      }
      if (jsonData.endTime) {
        this.endTime = SDate.newUtc(jsonData.endTime);
      }
    }
    if (!this.startTime || !this.startTime.isValid()) {
      this.startTime = SDate.getNormalized();
    }
  }

  isHistorical(): boolean {
    //console.log('isHistorical', this.startTime, SDate.new().subtract(Config.timelineEditStopsAfter, 'days'));
    return this.startTime.isBefore(SDate.new().subtract(Config.timelineEditStopsAfter, 'days'));
  }

  static filterToEffectiveNow(
    value: Partial<EboObjectTimePeriod>
    //*noUnusedParameters index: number,
    //*noUnusedParameters self: Array<Partial<EboObjectTimePeriod>>
  ) {
    const currentTime = SDate.new();
    return (
      value?.startTime.isSameOrBefore(currentTime) && (!value.endTime || value.endTime.isSameOrAfter(SDate.newUtc()))
    );
  }

  getTimeString(): string {
    return `${this.startTime.format('MM/DD/YY')} - ${this.endTime ? this.endTime.format('MM/DD/YY') : 'Current'}`;
  }
}
